import constants from './constants';

const {
  TOURNAMENT_MEMBER_STATUS,
  TOURNAMENT_MEMBER_ACTIONS,
} = constants;

const TOURNAMENT_MEMBER_STATUS_DATA = {
  [TOURNAMENT_MEMBER_STATUS.waited]: {
    id: TOURNAMENT_MEMBER_STATUS.waited,
    name: 'Ждёт решения',
    color: 'ui-warning',
  },
  [TOURNAMENT_MEMBER_STATUS.transfered]: {
    id: TOURNAMENT_MEMBER_STATUS.transfered,
    name: 'Переведён в другой раунд',
    color: 'ui-success',
  },
  [TOURNAMENT_MEMBER_STATUS.ended]: {
    id: TOURNAMENT_MEMBER_STATUS.ended,
    name: 'Завершил участие',
    color: 'ui-neutral',
  },
};

const TOURNAMENT_MEMBER_ACTIONS_DATA = {
  [TOURNAMENT_MEMBER_ACTIONS.transfer]: {
    id: TOURNAMENT_MEMBER_ACTIONS.transfer,
    name: 'Перевести в другой раунд',
    color: 'ui-primary',
    icon: '$ui-arrow-up-right',
  },
  [TOURNAMENT_MEMBER_ACTIONS.finish]: {
    id: TOURNAMENT_MEMBER_ACTIONS.finish,
    name: 'Завершить участие',
    color: 'ui-error',
    icon: '$ui-stop-circle',
  },
  [TOURNAMENT_MEMBER_ACTIONS.remove]: {
    id: TOURNAMENT_MEMBER_ACTIONS.remove,
    name: 'Удалить из группы',
    color: 'ui-error',
    icon: '$ui-delete',
  },
  [TOURNAMENT_MEMBER_ACTIONS.resume]: {
    id: TOURNAMENT_MEMBER_ACTIONS.resume,
    name: 'Возобновить участие',
    color: 'ui-primary',
    icon: '$ui-play-circle',
  },
};

export default {
  TOURNAMENT_MEMBER_STATUS_DATA,
  TOURNAMENT_MEMBER_ACTIONS_DATA,
};
